import {
  CostCentersDistributionQuery,
  CostCentersListQuery,
  CostCentersOptionsQuery,
} from 'generated/resources/graphql'

import {
  FormattedAssignment,
  FormattedAssignmentWithDeletion,
} from 'modules/finance/lib/costCenterAssignments'

export interface AllocationSelectOption {
  label: string
  value: string
  resourceId?: number
}

export const LINKABLE_RESOURCES: Record<AssignmentResourceKeys, AssignmentResourceKeys> = {
  Employee: 'Employee',
} as const

export interface AllocationOption {
  label: string
  resourceType: AssignmentResourceKeys
  resourceId: number
}

export type AssignmentsOptions = CostCentersOptionsQuery['costCenters']
export type AssignmentResourceKeys = keyof Omit<AssignmentsOptions, '__typename'>

export interface AssignmentsChange {
  assignmentsToCreate: Omit<FormattedAssignment, 'id' | 'name'>[]
  assignmentsToUpdate: (Omit<FormattedAssignmentWithDeletion, 'id' | 'name'> & { id: number })[]
}

export interface AllocationReference {
  id?: number
  referenceType: string
  referenceId: number
}

export type ResourceDistribution =
  CostCentersDistributionQuery['costCenters']['distributionsConnection']['nodes']

export type CostCenterDetails =
  CostCentersListQuery['costCenters']['costCentersConnection']['edges'][number]['node']
